import React from 'react';
import { FormattedMessage } from 'react-intl';
import { P, H2, Space, Button } from '@dnb/eufemia';
import { translationKeys } from '@pm-netbank/translations';
import ApplicationRequirementsContainer from '../ApplicationRequirementsContainer/ApplicationRequirementsContainer';
import OddApplicationRequirementItem from '../OddApplicationRequirementItem/OddApplicationRequirementItem';

export interface Props {
  onAcknowledgeInformation: () => void;
}

const OddApplicationInformation = ({ onAcknowledgeInformation }: Props) => {
  return (
    <div data-testid="odd-application-information">
      <P data-testid="odd-application-information-introduction">
        <FormattedMessage
          id={translationKeys.becomeCustomer.become_customer_information_intro}
        />
      </P>
      <Space bottom="large" />

      <H2 data-testid="odd-application-information-title">
        <FormattedMessage
          id={translationKeys.becomeCustomer.become_customer_information_title}
        />
      </H2>
      <ApplicationRequirementsContainer>
        <OddApplicationRequirementItem.Minutes />
        <OddApplicationRequirementItem.PersonalInfo />
        <OddApplicationRequirementItem.Usage />
      </ApplicationRequirementsContainer>
      <Space bottom="large" />
      <Button
        data-testid="odd-application-information-start-button"
        icon="chevron_right"
        icon_position="right"
        onClick={onAcknowledgeInformation}
      >
        <FormattedMessage
          id={
            translationKeys.becomeCustomer
              .become_customer_start_application_button
          }
        />
      </Button>
    </div>
  );
};

export default OddApplicationInformation;
